export interface PricingGroupInterface {
  id :number;
  name :string;
  status :string;
}

export interface PricingScheduleInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  status :PricingStatus;
  name :string;
  countingAlgorithm :CountingAlgorithm;
  modificationType :PriceModificationType;
  global :boolean;
  priceScheduleTiers ?:PricingTierInterface[];
}

export interface PricingLevelInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  status :PricingStatus;
  name :string;
  type :PricingLevelType;
  percentIncrease :number;
}

export interface PricingTierInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  status :PricingStatus;
  quantity :number;
  amount :number;
  priceScheduleId :number;
}

export interface PricingOverrideInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  status :PricingStatus;
  price :number;
  rfqId :number;
  priceScheduleTierId :number;
  priceLevelId :number;
}

export enum PriceModificationType {
  PERCENT = 'PERCENT',
  FIXED = 'FIXED',
}

export enum CountingAlgorithm {
  LINE_ITEM_QUANTITY = 'LINE_ITEM_QUANTITY',
}

export enum PricingStatus {
  ACTIVE = 'Active',
  DELETED = 'Deleted',
}

export enum PricingLevelType {
  PRICE_BASED = 'PRICE_BASED',
  COST_BASED = 'COST_BASED',
  MANUAL_BASED = 'MANUAL',
}

export enum PricingLevelTypeKeyValue {
  PRICE_BASED = 'Price Based',
  COST_BASED = 'Cost Based',
  MANUAL_BASED = 'Manual Based',
}

export interface BusinessAccountPriceOverridesInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  businessAccountId :number;
  sku :string;
  productName :string;
  rfqId :number;
  retailPrice :number;
  wholesalePrice :number;
  price :number;
}
